import { render, staticRenderFns } from "./FreSurchargePop2.vue?vue&type=template&id=15d5a7d3&scoped=true"
import script from "./FreSurchargePop2.vue?vue&type=script&lang=js"
export * from "./FreSurchargePop2.vue?vue&type=script&lang=js"
import style0 from "./FreSurchargePop2.vue?vue&type=style&index=0&id=15d5a7d3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5a7d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d5a7d3')) {
      api.createRecord('15d5a7d3', component.options)
    } else {
      api.reload('15d5a7d3', component.options)
    }
    module.hot.accept("./FreSurchargePop2.vue?vue&type=template&id=15d5a7d3&scoped=true", function () {
      api.rerender('15d5a7d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/popup/FreSurchargePop2.vue"
export default component.exports